import { applySnapshot, flow, types } from "mobx-state-tree";
import { pick } from 'lodash';
import { makeRequest } from 'js/services/Network';

export default types
  .model('StoreActivationPage', {
    count: 5,
    is_loading: false,
    micro_store_url: '',
    owner_name: '',
    page: 1,
  })
  .actions(self => ({
    load: flow(function* load(refresh = false) {
      let response;
      if (!self.is_loading) {
        refresh && applySnapshot(self, {});
        self.is_loading = true;
        try {
          response = yield makeRequest('my-items-data', null, pick(self, ['page', 'count']));
          self.micro_store_url = response.data.micro_store;
          self.owner_name = response.data.first_name || 'POD Seller';
          self.is_loading = false;
        } catch (error) {
          self.is_loading = false;
          throw error;
        }
      }
      return response;
    }),
  }))